<template>
  <!--驾驶舱首页-->
  <div class="homeContainer">
    <el-card class="box-card">
      <div slot="header">
        <p style="font-weight: bold;text-align: center;">IB每周日续下周7天临时证自动计算程序</p>
        <p style="font-size: 14px;text-align: center;margin-top: 10px;">
          TIPS：很久才续期一次和新办证人员只能从每周三开始算开始日期</p>
      </div>
      <div class="cardContainer flex flex-align-center">
        <div class="cardConL flex-1">
          <el-table
              :data="certificateNameList"
              border
              stripe>
            <el-table-column
                prop="name"
                label="姓名"
                align="center"
                width="100px">
            </el-table-column>
            <el-table-column
                prop="mobile"
                label="手机号"
                align="center"
                width="150px">
            </el-table-column>
            <el-table-column
                prop="idCardNum"
                label="身份证"
                align="center">
            </el-table-column>
            <el-table-column
                prop="whiteCardExpirationDate"
                label="白卡过期日期"
                align="center"
                width="150px">

              <template slot-scope="scope">
                <span
                    :class="{'danger' :scope.row.whiteCardExpirationDateFlag}">{{
                    scope.row.whiteCardExpirationDate
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="showNextStartTime"
                label="下周选择的续证日期"
                align="center"
                width="150px">
            </el-table-column>
            <el-table-column
                label="上周办证开始日期"
                align="center"
                width="250px">
              <template slot-scope="scope">
                <el-date-picker
                    v-model="scope.row.startTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择开始日期">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
                width="220px"
                align="center"
                label="操作">
              <template slot-scope="scope">
                <el-button type="primary" icon="el-icon-edit" @click="openAddPersonModal(true,scope.$index)">编辑
                </el-button>
                <el-button type="danger" icon="el-icon-delete" @click="delPerson(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="cardConR flex flex-v flex-align-center">
          <div>
            <el-button @click="openAddPersonModal(true)" type="warning">新增人员</el-button>
          </div>
          <div style="margin-top: 30px">
            <el-button @click="confirmDate" type="primary">开始计算日期</el-button>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="container">
        <p style="font-weight: bold;font-size: 25px;">邮件标题：关于米仓进场临时证的续期</p>
        <p style="font-weight: bold;font-size: 25px;margin: 10px 0;">收件人：524441@fedex.com</p>
        <p style="font-weight: bold;font-size: 25px;margin: 10px 0;">抄送给周凌志：zhoulz@micangtech.com</p>
        <p style="font-weight: bold;font-size: 25px;margin: 10px 0;">邮件内容：</p>
        <div class="zhengCon" id="emailContent">
          <p>Penny，</p>
          <p style="margin:10px 0">您好，以下人员麻烦帮忙办理续证：</p>
          <!--旧入场人员-->
          <ul class="oldPerson">
            <li v-for="(nameItem,index) in showEnterPersonList" :key="index">
              <div v-if="!nameItem.isNew">
                <span
                    style="display: inline-block;width: 120px;text-align: left;">{{ index + 1 }}、{{
                    nameItem.name
                  }}</span>
                <!--很久才续证一次的入场人员-->
                <span
                    v-show="nameItem.isLongTimeEnter">
                  <span v-show="nameItem.showLastWeekFlag">上次结束日期为无，</span>
                  续期为{{
                    nameItem.showLastStartTime
                  }}至{{ nameItem.showLastEndTime }}；</span>
                <!--很久才续证一次的入场人员-->
                <!--每周续证入场人员-->
                <span
                    v-show="!nameItem.isLongTimeEnter">
                  <span v-show="nameItem.showLastWeekFlag">上次结束日期为{{
                      nameItem.showLastStartTime
                    }}至{{ nameItem.showLastEndTime }}，</span>续期为{{ nameItem.showNextStartTime }}至{{
                    nameItem.showNextEndTime
                  }}<span
                    v-show="nameItem.whiteCardDate">，白卡{{ nameItem.showWhiteCardDate }}到期，要续白卡</span>；</span>
                <!--每周续证入场人员-->
              </div>
            </li>
          </ul>
          <!--旧入场人员-->
          <!--新入场人员-->
          <div class="newPerson" v-show="showNewEnterPersonList.length>0">
            <p class="newEnterPersonTitle">以下为新办证人员：</p>
            <ul>
              <li v-for="(nameItem,index) in showNewEnterPersonList" :key="index">
                <div>
                  <span
                      style="display: inline-block;width: 120px;text-align: left;">{{ index + 1 }}、{{
                      nameItem.name
                    }}</span>
                  <span>进场时间为{{ nameItem.showLastStartTime }}至{{
                      nameItem.showLastEndTime
                    }}，身份证：{{ nameItem.idCardNum }}，联系电话：{{ nameItem.mobile }}；</span>
                </div>
              </li>
            </ul>
            <p class="fileTitle">附件人员图片</p>
          </div>
          <!--新入场人员-->
        </div>
      </div>
      <div class="flex flex-pack-center">
        <el-button type="success" style="margin-right: 50px" @click="copyCon">复制邮件正文</el-button>
        <el-button type="primary" @click="sendEmail">发送邮件</el-button>
      </div>
    </el-card>
    <div id="companyFooter">
      Copyright©<span>{{ currentYear }}</span> 乐悦科技 All Rights Reserved.
      <a id="recordNumber" href="https://beian.miit.gov.cn" target="_blank">粤ICP备2023135202号</a>
    </div>
    <!--    新增人员modal-->
    <el-dialog title="新增人员" width="700px" :visible="addPersonFlag" :before-close="closeAddPersonModal"
               append-to-body>
      <div class="addPerson">
        <el-form ref="personForm" :model="personForm" :rules="personFormRules" label-width="250px">
          <el-form-item label="姓名：" prop="name">
            <div style="width: 200px">
              <el-input v-model="personForm.name"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="是否每周都续证人员：">
            <el-switch
                v-model="personForm.isEveryWeekRenewal"
                active-text="是"
                inactive-text="否"
                @change="isEveryWeekRenewalChange">
            </el-switch>
          </el-form-item>
          <el-form-item label="是否新进场人员：" v-show="!personForm.isEveryWeekRenewal">
            <el-switch
                v-model="personForm.isNew"
                active-text="是"
                inactive-text="否"
                @change="isNewPersonChange">
            </el-switch>
          </el-form-item>
          <el-form-item label="旧入场人员，是否很久才续证一次：" v-show="!personForm.isEveryWeekRenewal">
            <el-switch
                v-model="personForm.isLongTimeEnter"
                active-text="是"
                inactive-text="否"
                @change="isLongTimeEnterChange">
            </el-switch>
          </el-form-item>
          <el-form-item label="开始日期：" required>
            <el-date-picker
                v-model="personForm.startTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                v-if="personForm.isEveryWeekRenewal"
            >
            </el-date-picker>
            <el-date-picker
                v-model="personForm.startTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                :picker-options="timePickerOptions"
                v-else
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否需要续白卡：">
            <el-switch
                v-model="personForm.whiteCardRenewal"
                active-text="是"
                inactive-text="否"
                @change="whiteCardRenewalChange">
            </el-switch>
          </el-form-item>
          <el-form-item label="白卡过期日期：" required v-show="personForm.whiteCardRenewal">
            <el-date-picker
                v-model="personForm.whiteCardDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择白卡过期日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否显示：">
            <el-switch
                v-model="personForm.showFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="显示"
                inactive-text="不显示">
            </el-switch>
          </el-form-item>
          <template v-if="!personForm.isEveryWeekRenewal">
            <el-form-item label="新入场人员手机：">
              <el-input v-model="personForm.mobile"></el-input>
            </el-form-item>
            <el-form-item label="新入场人员身份证号码：">
              <el-input v-model="personForm.idCardNum"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="列表显示白卡过期日期：">
            <el-date-picker
                v-model="personForm.whiteCardExpirationDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择列表显示白卡过期日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="confirmAddPerson">保存</el-button>
        <el-button @click="closeAddPersonModal">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {copyText, deepClone, parseTime, selectText, timePickerOptions} from "@/utils";
import {getAllUsers, createUser, editUsers, delUsers, sendQiYeEmail} from '@/api/common'

export default {
  name: "Home",
  data: () => {
    return {
      currentYear: new Date().getFullYear(), // 当前年
      timePickerOptions,
      certificateNameList: [],//证列表
      oldCertificateNameList: [],
      addPersonFlag: false,//新增人员modal flag
      personForm: {
        id: '',
        name: '',
        startTime: '',//开始日期
        isEveryWeekRenewal: true,//是否每周都续证人员
        isNew: false,//是否新进场人员
        isLongTimeEnter: false,//是否很久才续证一次
        whiteCardRenewal: false,//白卡续期
        whiteCardDate: '',//白卡过期时间
        showFlag: true, //1：显示  0：不显示
        mobile: '',//新入场人员手机
        idCardNum: ''//新入场人员身份证
      },//添加新人员form
      editIndex: null,//编辑的索引值
      personFormRules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ]
      },
      showEnterPersonList: [],//旧进场人员
      showNewEnterPersonList: [],//新进场人员
      sendEmailBtnFlag: false,//按钮限制
      emailInfo: {
        sender: 'huangcm@micangtech.com',//发件人邮箱
        consignee: '524441@fedex.com',// pigpigmou@163.com  收件人邮箱
        title: '关于米仓进场临时证的续期',
        CCPerson: 'zhoulz@micangtech.com'//抄送人邮箱
      }
    }
  },
  mounted() {
    this.getPerson()
  },
  methods: {
    getPerson() {
      const rightNow = new Date().getTime()
      getAllUsers().then(res => {
        const {data} = res
        const personList = data
        personList.map(item => {
          const whiteCardExpirationDate = new Date(item.whiteCardExpirationDate).getTime()
          item.isEveryWeekRenewal = item.isEveryWeekRenewal === 1
          item.isNew = item.isNew === 1
          item.isLongTimeEnter = item.isLongTimeEnter === 1
          item.whiteCardRenewal = item.whiteCardRenewal === 1
          item.showLastWeekFlag = item.showLastWeekFlag === 1
          item.showWhiteCardDate = item.whiteCardDate
          item.whiteCardExpirationDateFlag = whiteCardExpirationDate < rightNow
        })
        this.certificateNameList = personList
        this.getNewEnterPersonList()
      }).catch(err => {

      })
    },
    addPerson(addFlag) {//新增人员
      const httpMethods = addFlag ? createUser : editUsers
      const personForm = this.personForm
      let endTime = new Date(personForm.startTime).getTime() + 3600 * 1000 * 24 * 6
      let nextWeekStartTime = new Date(personForm.startTime).getTime() + 3600 * 1000 * 24 * 7
      let nextWeekEndTime = new Date(personForm.startTime).getTime() + 3600 * 1000 * 24 * 13
      let params = {
        name: personForm.name,
        startTime: personForm.startTime,//开始日期
        isEveryWeekRenewal: personForm.isEveryWeekRenewal ? 1 : 0,//是否每周都续证人员
        isNew: personForm.isNew ? 1 : 0,//是否新进场人员
        isLongTimeEnter: personForm.isLongTimeEnter ? 1 : 0,//是否很久才续证一次
        whiteCardRenewal: personForm.whiteCardRenewal ? 1 : 0,//白卡续期
        whiteCardDate: personForm.whiteCardDate,//白卡过期时间
        showLastStartTime: parseTime(personForm.startTime, '{m}月{d}日'),//上周开始日期
        showLastEndTime: parseTime(endTime, '{m}月{d}日'), //上周结束日期
        showNextStartTime: parseTime(nextWeekStartTime, '{m}月{d}日'),//下周开始日期
        showNextEndTime: parseTime(nextWeekEndTime, '{m}月{d}日'),//下周结束日期
        showFlag: personForm.showFlag ? 1 : 0, //1：显示  0：不显示
        showLastWeekFlag: personForm.isEveryWeekRenewal ? 1 : 0,//是否显示上周结束日期
        mobile: personForm.mobile,//新入场人员手机
        idCardNum: personForm.idCardNum,//新入场人员身份证
        whiteCardExpirationDate: personForm.whiteCardExpirationDate,//列表显示的白卡日期
      }
      if (!addFlag) {
        params.id = personForm.id
      }
      httpMethods(params).then(res => {
        this.$message({
          type: 'success',
          message: addFlag ? '添加成功' : '编辑成功'
        })
        this.getPerson()
      }).catch(() => {

      })
    },
    confirmDate() {//确认日期
      let name = ''
      this.certificateNameList.map(item => {
        if (item.startTime) {
          let endTime = new Date(item.startTime).getTime() + 3600 * 1000 * 24 * 6
          let nextWeekStartTime = new Date(item.startTime).getTime() + 3600 * 1000 * 24 * 7
          let nextWeekEndTime = new Date(item.startTime).getTime() + 3600 * 1000 * 24 * 13
          let whiteCardDate = item.whiteCardDate ? new Date(item.whiteCardDate) : null
          item.showLastStartTime = parseTime(item.startTime, '{m}月{d}日')
          item.showLastEndTime = parseTime(endTime, '{m}月{d}日')
          item.showNextStartTime = parseTime(nextWeekStartTime, '{m}月{d}日')
          item.showNextEndTime = parseTime(nextWeekEndTime, '{m}月{d}日')
          item.showWhiteCardDate = whiteCardDate ? parseTime(whiteCardDate, '{m}月{d}日') : ''
        } else {
          name += item.name + '、'
        }
      })
      if (name.indexOf('、') > 0) {
        name = name.substring(0, name.lastIndexOf('、'))
        this.$message({
          message: `！！！！${name}的开始日期没有选择`,
          type: 'warning'
        });
      }
      this.certificateNameList.map((item, index) => {
        const personForm = item
        let endTime = new Date(personForm.startTime).getTime() + 3600 * 1000 * 24 * 6
        let nextWeekStartTime = new Date(personForm.startTime).getTime() + 3600 * 1000 * 24 * 7
        let nextWeekEndTime = new Date(personForm.startTime).getTime() + 3600 * 1000 * 24 * 13
        let params = {
          id: personForm.id,
          name: personForm.name,
          startTime: personForm.startTime,//开始日期
          isEveryWeekRenewal: personForm.isEveryWeekRenewal ? 1 : 0,//是否每周都续证人员
          isNew: personForm.isNew ? 1 : 0,//是否新进场人员
          isLongTimeEnter: personForm.isLongTimeEnter ? 1 : 0,//是否很久才续证一次
          whiteCardRenewal: personForm.whiteCardRenewal ? 1 : 0,//白卡续期
          whiteCardDate: personForm.whiteCardDate,//白卡过期时间
          showLastStartTime: parseTime(personForm.startTime, '{m}月{d}日'),//上周开始日期
          showLastEndTime: parseTime(endTime, '{m}月{d}日'), //上周结束日期
          showNextStartTime: parseTime(nextWeekStartTime, '{m}月{d}日'),//下周开始日期
          showNextEndTime: parseTime(nextWeekEndTime, '{m}月{d}日'),//下周结束日期
        }
        editUsers(params).then(res => {
          if ((index + 1) === this.certificateNameList.length) {//最后一条才调用
            this.getPerson()
          }
        }).catch(() => {

        })
      })
    },
    sendEmail() {//跳转163邮箱
      this.$confirm(`是否确认发送邮件，一经发出无法拦截邮件！当有新进场人员需要上传图片时，请通过复制邮件内容到163企业邮箱发送邮件？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.sendEmailBtnFlag) {
          return false
        }
        let oldEnterPersonListHtml = ''
        let newEnterPersonListHtml = ''
        this.showEnterPersonList.map((nameItem, index) => {
          let showLastWeekHtml = ''
          oldEnterPersonListHtml += `<li style="margin-bottom: 10px;text-indent: 20px;">`
          if (!nameItem.isNew) {
            oldEnterPersonListHtml += `<div><span style="display: inline-block;width: 120px;text-align: left;">${index + 1}、${nameItem.name}</span>`
          }
          if (nameItem.isLongTimeEnter) {
            if (nameItem.showLastWeekFlag) {//显示上周日期
              showLastWeekHtml = `上次结束日期为无，`
            }
            oldEnterPersonListHtml += `<span>${showLastWeekHtml}续期为${nameItem.showLastStartTime}至${nameItem.showLastEndTime}；</span>`
          } else {
            if (nameItem.showLastWeekFlag) {//显示上周日期
              showLastWeekHtml = `上次结束日期为${nameItem.showLastStartTime}至${nameItem.showLastEndTime}，`
            }
            oldEnterPersonListHtml += `<span>${showLastWeekHtml}续期为${nameItem.showNextStartTime}至${nameItem.showNextEndTime}`
            if (nameItem.whiteCardDate) {
              oldEnterPersonListHtml += `<span>，白卡${nameItem.showWhiteCardDate}到期，要续白卡</span>`
            }
            oldEnterPersonListHtml += `；</span>`
          }
          if (!nameItem.isNew) {
            oldEnterPersonListHtml += `</div>`
          }
          oldEnterPersonListHtml += `</li>`
        })
        if (this.showNewEnterPersonList.length > 0) {
          newEnterPersonListHtml += `<div class="newPerson" style="margin-top: 10px;"><p class="newEnterPersonTitle" style="margin-bottom: 10px;">以下为新办证人员：</p><ul style="list-style: none;">`
          this.showNewEnterPersonList.map((nameItem, index) => {
            newEnterPersonListHtml += `<li style="margin-bottom: 10px;text-indent: 20px;">
                            <div>
                                <span style="display: inline-block;width: 120px;text-align: left;">${index + 1}、${nameItem.name}</span>
                                <span>进场时间为${nameItem.showLastStartTime}至${nameItem.showLastEndTime}，身份证：${nameItem.idCardNum}，联系电话：${nameItem.mobile}；</span>

                            </div>
                        </li>`
          })
          newEnterPersonListHtml += `</ul><p class="fileTitle" style="margin-top: 10px;">附件人员图片</p></div>`
        }
        const emailInfo = this.emailInfo
        const params = {
          from: emailInfo.sender,
          to: emailInfo.consignee,
          subject: emailInfo.title,
          cc: emailInfo.CCPerson,
          html: `
                <div style="line-height: 1;font-size: 15px;">
                    <p>Penny，</p>
                    <p style="margin:10px 0">您好，以下人员麻烦帮忙办理续证：</p>
                    <ul class="oldPerson" style="list-style: none;">
                        ${oldEnterPersonListHtml}
                    </ul>
                    ${newEnterPersonListHtml}
                </div>`
        }
        this.sendEmailBtnFlag = true
        sendQiYeEmail(params).then(res => {
          this.$message({
            type: 'success',
            message: '邮件发送成功'
          })
          this.sendEmailBtnFlag = false
        }).catch(() => {
          this.sendEmailBtnFlag = false
        })
      })
    },
    copyCon() {
      let emailContent = selectText(document.querySelector('#emailContent'))
      copyText(emailContent, () => {
        this.$message({
          message: `邮件内容复制成功`,
          type: 'success'
        });
      })
    },
    confirmAddPerson() {//确认新增人员
      this.$refs['personForm'].validate((valid) => {
        if (valid) {
          const personForm = deepClone(this.personForm)
          if (!personForm.startTime) {
            this.$message({
              message: `请选择开始日期`,
              type: 'warning'
            });
            return false
          }

          const personItem = {
            ...personForm,
            showLastStartTime: '',//上周开始日期
            showLastEndTime: '', //上周结束日期
            showNextStartTime: '',//下周开始日期
            showNextEndTime: '',//下周结束日期
          }
          let loadFlag = false
          if (this.editIndex !== null) {//编辑
            this.addPerson(false)
          } else {//新增
            for (let i = 0; i < this.certificateNameList.length; i++) {
              const item = this.certificateNameList[i]
              if (personItem.name === item.name) {
                loadFlag = true
                break
              }
            }
            if (loadFlag) {
              this.$message({
                message: `姓名重复，请检查`,
                type: 'warning'
              });
              return false
            }
            this.addPerson(true)
            this.getNewEnterPersonList()
          }
          if (loadFlag) {
            return false
          }
          this.closeAddPersonModal(false)
        }
      })
    },
    delPerson(item) {//删除人员
      this.$confirm('是否删除这条数据？', '提示', {
        type: 'warning'
      }).then(res => {
        delUsers({
          id: item.id
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getPerson()
        }).catch(() => {

        })
      })
    },
    openAddPersonModal(flag, index) {//控制新增、编辑人员modal
      if (flag && index !== undefined) {
        const item = deepClone(this.certificateNameList[index])
        this.editIndex = index
        this.personForm = {
          id: item.id,
          name: item.name,
          startTime: item.startTime,//开始日期
          isEveryWeekRenewal: item.isEveryWeekRenewal,//是否每周都续证人员
          isNew: item.isNew,//是否新进场人员
          isLongTimeEnter: item.isLongTimeEnter,//是否很久才续证一次
          whiteCardRenewal: !!item.whiteCardDate,//白卡续期
          whiteCardDate: item.whiteCardDate,//白卡过期时间
          showFlag: item.showFlag === 1, //1：显示  0：不显示
          mobile: item.mobile,//新入场人员手机
          idCardNum: item.idCardNum,//新入场人员身份证
          showLastWeekFlag: item.isEveryWeekRenewal,
          whiteCardExpirationDate: item.whiteCardExpirationDate
        }
      }
      this.addPersonFlag = flag
    },
    closeAddPersonModal() {
      this.personForm = {
        id: '',
        name: '',
        startTime: '',//开始日期
        isEveryWeekRenewal: true,//是否每周都续证人员
        isNew: false,//是否新进场人员
        isLongTimeEnter: false,//是否很久才续证一次
        whiteCardRenewal: false,//白卡续期
        whiteCardDate: '',//白卡过期时间
        showFlag: true, //1：显示  0：不显示
        mobile: '',//新入场人员手机
        idCardNum: ''//新入场人员身份证
      }
      this.editIndex = null
      this.$refs.personForm.resetFields()
      this.openAddPersonModal(false)
    },
    isNewPersonChange() {
      this.personForm.isLongTimeEnter = !this.personForm.isNew
    },
    isLongTimeEnterChange() {
      this.personForm.isNew = !this.personForm.isLongTimeEnter
    },
    isEveryWeekRenewalChange() {
      this.personForm.isLongTimeEnter = !this.personForm.isEveryWeekRenewal
      this.personForm.isNew = !this.personForm.isNew
    },
    whiteCardRenewalChange() {
      if (!this.personForm.whiteCardRenewal) {
        this.personForm.whiteCardDate = ''
      } else {
        this.personForm.whiteCardDate = this.personForm.whiteCardExpirationDate
      }
    },
    getNewEnterPersonList() {//获取新入场人员的list
      let enterPersonList = []
      let newEnterPersonList = []
      this.certificateNameList.map(item => {
        if (item.isNew) {
          newEnterPersonList.push(item)
        } else {
          enterPersonList.push(item)
        }
      })
      this.showEnterPersonList = enterPersonList
      this.showNewEnterPersonList = newEnterPersonList
    }
  }
};
</script>

<style scoped lang="scss">
.zhengCon li, .newPerson li {
  margin-bottom: 10px;
  text-indent: 20px;
}

.newPerson, .fileTitle {
  margin-top: 10px;
}

.newEnterPersonTitle {
  margin-bottom: 10px;
}

.cardConL {
  margin-right: 30px;
}

.cardConR {
  width: 200px;
}

#companyFooter {
  font-size: 12px;
  margin-top: 15px;
  text-align: center;
}

.cardContainer {
  overflow-x: auto;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #888 transparent; /* 主体颜色和轨道颜色 */

  /* Webkit 内核滚动条样式 */
  &::-webkit-scrollbar {
    width: 8px; /* 滚动条宽度 */
  }

  &::-webkit-scrollbar-track {
    background-color: transparent; /* 轨道背景颜色 */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888; /* 滚动条主体颜色 */
    border-radius: 10px; /* 圆角大小 */
  }
}
</style>
